export const BACKEND_URL = "https://timasmart-8e822227718b.herokuapp.com"



// "http://192.168.0.14:8080"
//  "https://timasmart-8e822227718b.herokuapp.com"




// WEB




